<div class="flex-centered flex-row">
  <small class="helper-color-primary-700 mr-2"> {{ titlle() }} </small>
  <mat-spinner color="primary" [diameter]="height() - 4"></mat-spinner>
</div>
